import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "name", "value"]

import { watch, onMounted, ref, onBeforeMount, computed, toRef } from "vue";
import { useCurrencyInput, CurrencyInputOptions } from "vue-currency-input";
import { useField } from "vee-validate";
import { Schema, object } from "yup";
import { FormField, FormOption } from "@/types/form";

interface Props {
  name: string;
  field?: FormField;
  options?: CurrencyInputOptions;
  initialValue?: string | number | null;
  modelValue?: string | number | null | object | unknown;
  mode?: "add" | "edit" | "view";
  rules?: Schema;
  disabled: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CurrencyInput',
  props: {
    name: {},
    field: {},
    options: {},
    initialValue: {},
    modelValue: {},
    mode: {},
    rules: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const name = toRef(props, "name");

const defaultOptions = ref({
  currency: "USD",
  precision: 2,
  autoDecimalDigits: false,
});

const { formattedValue, numberValue, inputRef, setValue } = useCurrencyInput(
  props.options || defaultOptions.value
);

const { handleChange, value, errors } = useField(
  name.value || "",
  props.rules || object({})
);

onMounted(() => {
  // Currently there is a bug where you have to wait until after mount for useCurrencyInput to properly set the value
  setTimeout(() => {
    // sets the initial value if provided
    if (value.value) {
      setValue(Number(value.value));
    }
  }, 300);
});

watch(numberValue, (newValue, oldValue) => {
  // sync it with vee-validate, this will trigger validation
  handleChange(newValue);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    class: "currency",
    id: name.value,
    name: name.value,
    ref_key: "inputRef",
    ref: inputRef,
    type: "text",
    value: _unref(formattedValue)
  }, null, 8, _hoisted_1))
}
}

})